import type { Coordinate } from '../helpers/geo';

export enum GoogleAddressComponentTypes {
  None = 'none',
  Route = 'route',
  StreetNumber = 'street_number',
  Locality = 'locality',
  SubLocality = 'sublocality',
  SubLocalityLevel = 'sublocality_level_1',
  PostalTown = 'postal_town',
  Country = 'country',
  PostalCode = 'postal_code',
}

export type PlaceId = string;

export interface Location {
  formattedAddress: string;
  position: Coordinate;
  route?: string;
  streetNumber?: string;
  locality?: string;
  subLocality?: string;
  postalTown?: string;
  country?: string;
  postalCode?: string;
}

export interface LocationCriteria {
  position?: Coordinate;
  place?: PlaceId;
  language?: string;
}
